// lib/firebase/firebaseClient.ts
import { Analytics, getAnalytics, isSupported } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { GoogleAuthProvider, browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore' // Importa Firestore

export { GoogleAuthProvider }

const firebaseConfig = {
  apiKey: 'AIzaSyBc2_u6WGwKVvoq51Wji3lZfuc13yfm1NU',
  authDomain: 'barmanager-trivify.firebaseapp.com',
  projectId: 'barmanager-trivify',
  storageBucket: 'barmanager-trivify.appspot.com',
  messagingSenderId: '811470643460',
  appId: '1:811470643460:web:18422f9feade02beb03051'
}

// Inicializar Firebase app
const app = initializeApp(firebaseConfig)

// Inicializar Auth
export const auth = getAuth(app)
setPersistence(auth, browserLocalPersistence).catch((err) => {
  console.error('Failed to set Firebase auth persistence to browserLocalPersistence', err)
})
auth.languageCode = 'es'

// Provider de Google listo para usar en signInWithPopup / signInWithRedirect.
// Forzamos `select_account` para que el popup siempre pregunte qué cuenta usar
// y no logue silenciosamente con la primera del navegador.
export const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({ prompt: 'select_account' })

// Inicializar Firestore
export const fireStore = getFirestore(app) // Inicializa Firestore y lo exporta

// Inicializar Analytics sólo en el lado del cliente
export let analytics: Analytics
isSupported().then((isSupported) => {
  if (isSupported) {
    analytics = getAnalytics(app)
  }
})
